import { useQuery, useMutation } from 'react-query'
import { getAccountGovernanceMaps } from '../api/account'
import useAccountQueries from '../api/accountQueries'
import { useAppSelector } from 'app/state'

const queryKeys = {
  maps: ['accountGovernanceMaps'] as const
}

export const useAccountGovernanceMaps = () => {
  const user = useAppSelector((state) => state.users.me)
  return useQuery({
    queryKey: queryKeys.maps,
    queryFn: getAccountGovernanceMaps,
    enabled: !!user
  })
}

export const useUpdateAccountGovernanceMaps = () => {
  const { queries } = useAccountQueries()
  return useMutation(queries.updateAccountGovernanceMaps)
}
